import React, { useState, useEffect } from 'react';
import BackButton from '../_Shared/BackButton';
import { Form, Col, InputGroup } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { Formik } from 'formik';
import * as Yup from 'yup';
import { numberValidation, monthValidation } from '../_Shared/Validation';
import result from '../_Shared/Result';
import formulaDefinition from '../_Shared/FormulaDefinition';

function UsedVehiclesDaysSupplyInUnits() {
    const [usedInventory, setUsedInventory] = useState(0);
    const [usedVehicle, setUsedVehicle] = useState(0);
    const [months, setMonths] = useState(0);
    const [total, setTotal] = useState(0);
    const history = useHistory();


    useEffect(() => {
        if (months == ' ') {
            setTotal(
                ((parseInt(usedInventory) / parseInt(usedVehicle)) * 30)
            );
        }
        else {
            setTotal(
                ((parseInt(usedInventory) / (parseInt(usedVehicle) / parseInt(months))) * 30)
            );
        }
    }, [usedInventory, usedVehicle, months])

    function clickResult() {
        history.push(
            {
                pathname: `/usedvehiclesdaysdupplyinunitsresult?total=${parseInt(total)}`
            })
    }

    const validationSchema = Yup.object({
        usedInventory: numberValidation,
        usedVehicle: numberValidation,
        months: monthValidation
    });

    const def = <span>Number of Used Vehicles in Inventory ÷ Average Number of Used Vehicles Sold per month x Number of Working Days per Month</span>;

    return (
        <Formik
            initialValues={{ usedInventory: "", usedVehicle: "", months: "" }}
            validationSchema={validationSchema}
            onSubmit={e => {
                clickResult();
            }}
        >
            {({ handleSubmit, handleChange, values, errors }) => (

                <div className="container">
                    <main role="main">
                        <div className="jumbotron ">
                            <div className="col-sm-10 mx-auto">
                                <BackButton />
                                <h2 className="text-center">Number of Used Vehicles in Units</h2>

                                {formulaDefinition(def)}

                                <Form onSubmit={handleSubmit}>
                                    <Form.Row>

                                        <Form.Group as={Col} md="12" mb="3" controlId="usedInventory">
                                            <Form.Label>Used Vehicle Inventory Units</Form.Label>
                                            <InputGroup className="mb-2"><InputGroup.Prepend><InputGroup.Text>$</InputGroup.Text></InputGroup.Prepend>
                                            <Form.Control size="lg" type="number" name="usedInventory" value={values.usedInventory} isInvalid={!!errors.usedInventory}
                                                onChange={e => { handleChange(e); setUsedInventory(e.target.value) }} />
                                                <Form.Control.Feedback type="invalid">{errors.usedInventory}</Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>

                                        <Form.Group as={Col} md="12" mb="3" controlId="usedVehicle">
                                            <Form.Label>Used Retail Units Sold</Form.Label>
                                            <InputGroup className="mb-2"><InputGroup.Prepend><InputGroup.Text>$</InputGroup.Text></InputGroup.Prepend>
                                            <Form.Control size="lg" type="number" name="usedVehicle" isInvalid={!!errors.usedVehicle}
                                                onChange={e => { handleChange(e); setUsedVehicle(e.target.value) }} />
                                                <Form.Control.Feedback type="invalid">{errors.usedVehicle}</Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>

                                        <Form.Group as={Col} md="12" mb="3" controlId="months">
                                            <Form.Label>Number of Months</Form.Label>
                                            <InputGroup className="mb-2"><InputGroup.Prepend><InputGroup.Text>#</InputGroup.Text></InputGroup.Prepend>
                                            <Form.Control size="lg" type="number" name="months" isInvalid={!!errors.months}
                                                onChange={e => { handleChange(e); setMonths(e.target.value) }} />
                                                <Form.Control.Feedback type="invalid">{errors.months}</Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>

                                    </Form.Row>
                                    <p className="pb-5">
                                        <button className="btn-lg btn-primary btn-block" type="submit">Calculate &raquo;</button>
                                    </p>
                                </Form>
                            </div>
                        </div>
                    </main>
                </div>
            )}
        </Formik>
    );

}

function UsedVehiclesDaysSupplyInUnitsResult() {
    const urlParams = new URLSearchParams(window.location.search);
    const title = "Used Vehicles Days Supply in Units";
    const total = urlParams.get('total') + " Days";
    const ratio = <p>30 Days<br /><h2>12 turns per year</h2></p>;

    const cond = parseFloat(total) <= 30.00;

    return (
        <div>
            {result(title, total, ratio, cond)}
        </div>
    );
}


export {
    UsedVehiclesDaysSupplyInUnits,
    UsedVehiclesDaysSupplyInUnitsResult
}